import { motion } from "framer-motion";

const steps = [
  {
    title: "Upload Your Medical Records",
    description:
      "Drag and drop lab reports, discharge summaries, imaging reports, prescriptions, or connect directly to your hospital's patient portal. We support PDF, JPEG, DICOM, and HL7 formats."
  },
  {
    title: "AI Parses & Structures Your Data",
    description:
      "Our clinical NLP engine reads every document, extracts entities like diagnoses, medications, dosages, and dates, and maps them to standardized medical ontologies (ICD-10, SNOMED-CT, LOINC)."
  },
  {
    title: "Build Your Unified Health Timeline",
    description:
      "All records are organized chronologically into your personal timeline with smart categorization — conditions, medications, labs, imaging, visits, procedures, and vaccinations."
  },
  {
    title: "Receive Actionable AI Insights",
    description:
      "HealthTimeline AI surfaces patterns, flags anomalies, predicts risk trajectories, and generates physician-ready summaries with evidence-based recommendations."
  },
  {
    title: "Share & Collaborate Securely",
    description:
      "Invite doctors, specialists, or caregivers with granular access controls. Export structured reports as PDF or FHIR bundles for seamless clinical handoffs."
  }
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="mx-auto max-w-7xl px-6 py-12 md:px-10">
      <div className="rounded-2xl border border-gray-200/80 bg-gray-50/90 px-6 py-14 shadow-sm md:px-12 md:py-16">
        <div className="mx-auto mb-12 max-w-3xl text-center">
          <span className="inline-block rounded-full bg-emerald-100 px-4 py-1 text-xs font-semibold uppercase tracking-wide text-emerald-800">
            How It Works
          </span>
          <h2 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 md:text-4xl">
            From Upload to Insight in Minutes
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Five straightforward steps to unlock the full power of your medical data.
          </p>
        </div>

        <ol className="mx-auto max-w-3xl space-y-10">
          {steps.map((step, index) => (
            <motion.li
              key={step.title}
              initial={{ opacity: 0, x: -12 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.06 }}
              className="flex gap-5"
            >
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gray-200 text-sm font-semibold text-gray-600">
                {index + 1}
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-gray-600">{step.description}</p>
              </div>
            </motion.li>
          ))}
        </ol>
      </div>
    </section>
  );
}
